export enum JobStatus {
  Started = 'started',
  Finished = 'finished',
  Failed = 'failed',
}

export const RateLimitKeyError = 'rate-limit';
export const MaxJobTimeout = 10 * 60 * 1000;
export const SingleJobStatusCheckInterval = 5000;
